import script from "./plans.vue?vue&type=script&setup=true&lang=js"
export * from "./plans.vue?vue&type=script&setup=true&lang=js"

import "./plans.vue?vue&type=style&index=0&id=4d7f7b0a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7f7b0a"]])

export default __exports__